import React, { createContext, useContext, useState, useEffect } from 'react';
import { customerAuthService } from '../services/customerAuthService';

const CustomerAuthContext = createContext();

export const useCustomerAuth = () => {
  const context = useContext(CustomerAuthContext);
  if (!context) {
    throw new Error('useCustomerAuth must be used within CustomerAuthProvider');
  }
  return context;
};

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = customerAuthService.onAuthStateChange((customerData) => {
      setCustomer(customerData);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const register = async (customerData, password) => {
    const result = await customerAuthService.registerCustomer(customerData, password);
    return result;
  };

  const login = async (email, password) => {
    const result = await customerAuthService.loginCustomer(email, password);
    return result;
  };

  const loginWithDocument = async ({ document, password }) => {
    const result = await customerAuthService.loginWithDocument(document, password);
    return result;
  };

  const registerCustomer = async (customerData) => {
    const result = await customerAuthService.registerCustomerByDocument(customerData);
    return result;
  };

  const logout = async () => {
    await customerAuthService.logoutCustomer();
  };

  const changePassword = async (currentPassword, newPassword) => {
    await customerAuthService.changePassword(currentPassword, newPassword);
  };

  const value = {
    customer,
    login,
    loginWithDocument,
    register,
    registerCustomer,
    logout,
    changePassword,
    loading
  };

  return (
    <CustomerAuthContext.Provider value={value}>
      {children}
    </CustomerAuthContext.Provider>
  );
};
